import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { ICourse } from "utils/types";
import { CardBadge } from "common";



const Card = styled(motion.div)`
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s;
  cursor: pointer;
`;

const CardImage = styled.div<{ imageUrl: string }>`
  height: 160px;
  background-image: url(${(props) => props.imageUrl});
  background-size: cover;
  background-position: center;
  position: relative;
`;

const Tag = styled.span`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: #5575f7;
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
`;

const CardContent = styled.div`
  padding: 1rem;
`;

const CardTitle = styled.h3`
  font-size: 16px;
  font-weight: 500;
  color: #111827;
  margin: 0 0 0.5rem 0;
  line-height: 1.4;
  font-family: "Manrope-Bold";
`;

const CardDescription = styled.p`
  font-size: 14px;
  color: #6b7280;
  margin: 0 0 1rem 0;
  line-height: 1.5;
`;

const CardMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
  font-size: 12px;
  color: #6b7280;
`;

const MetaItem = styled.span`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  background: #f6f8ff;
  padding: 7px;
  border-radius: 8px;
  color: #5575f7;
`;

export interface CourseCardProps {
  course: ICourse;
  onMoveToCourseDetail: (course: ICourse) => void;
}
export const CourseCard: React.FC<CourseCardProps> = ({
  course, onMoveToCourseDetail,
}) => {

  return (
    <Card
      whileHover={{ y: -4 }}
      transition={{ duration: 0.2 }}
      onClick={() => onMoveToCourseDetail(course)}
    >
      <CardImage imageUrl={course.image}>
        {<CardBadge style={{ position: "absolute"}} $isPremium={course.courseType === "premium"}>{course.courseType}</CardBadge>}
      </CardImage>
      <CardContent>
        <CardTitle>{course.title}</CardTitle>
        <CardDescription>{course.description}</CardDescription>
        <CardMeta>
          {(() => {
            const quizzes = course.availableQuizzes || [];
            const visibleQuizzes = quizzes.slice(0, 4);
            const remainingCount = quizzes.length - 4;

            return (
              <>
                {visibleQuizzes.map((quiz, index) => (
                  <MetaItem key={`${quiz.quizId}-${index}`}>{quiz.quizYear}</MetaItem>
                ))}
                {remainingCount > 0 && (
                  <MetaItem key="more">+{remainingCount}</MetaItem>
                )}
              </>
            );
          })()}
        </CardMeta>
      </CardContent>
    </Card>
  );
};
